import * as React from 'react';
import { Nav } from '../modules';
import { INavLink } from '../../interfaces/interfaces';
import { NavLink, Link, RouteComponentProps, withRouter } from 'react-router-dom';

interface INavbarProps extends RouteComponentProps<{ language: string }> {
  items: INavLink[];
  isOpened: boolean;
}

interface INavbarState {
  isOpened: boolean;
  openedMainItem: string | null;
  openedItems: string[];
}
class Navbar extends React.Component<INavbarProps> {
  public state: INavbarState;

  constructor(props: INavbarProps) {
    super(props);
    this.state = {
      isOpened: false,
      openedMainItem: null,
      openedItems: []
    };

    this.toggleMainItem = this.toggleMainItem.bind(this);
    this.toggleItem = this.toggleItem.bind(this);
  }

  public toggleMainItem(key: string) {
    this.setState({
      openedMainItem: key,
    });
  }

  public toggleItem(key: string) {
    const items: string[] = this.state.openedItems;
    const index = items.indexOf(key);

    if (index !== -1) {
      items.splice(index, 1);
    } else {
      items.push(key);
    }

    this.setState({ openedItems: items });
  }

  public render() {

    let isActive: boolean = false;
    const findMatch = (category: any) => {
      if (isActive) { return; }

      if (this.props.history.location.pathname.replace('products/', '').includes(category.link.replace('products/', ''))) {
        isActive = true;
      }

      category.sub.map((subCategory: any) => {
        findMatch(subCategory);
      });
    };

    const isRootActive = (category: any): boolean => {
      findMatch(category);
      const root = isActive;
      isActive = false;
      return root;
    };

    return (
      <React.Fragment>
        {/* Navbar */}

        <div className={'nav__navbar' + (this.props.isOpened ? ' isOpened' : '')}>
          {/* Lvl 1 */}
          {this.props.items.map((category: any, i) => {
            return (
              <div
                key={i}
                className={
                  'nav__item' +
                  (category.sub && category.sub.length > 0 ? ' hasSub' : '') +
                  (this.state.openedMainItem === `${i}` ? ' isOpened' : '')
                }
              >
                <NavLink
                  to={'#'}
                  className="nav__link"
                  // isActive={isActive.bind(category)}
                  isActive={() => {
                    return isRootActive(category);
                  }}
                  onClick={e => {
                    if (category.sub && category.sub.length > 0) {
                      e.preventDefault();
                      this.toggleMainItem(`${i}`);
                    }
                  }}
                >

                  <span>
                    {category.value}
                  </span>

                </NavLink>

                {/* Lvl 2 */}
                {category.sub &&
                  category.sub.length > 0 && (
                    <div className={'nav__subnav'}>
                      <Nav type="subnav">
                        {/* Hotfix */}
                        {(category.value == 'Značky' && category.sub.length > 7) ?
                          (() => {
                            const sub = JSON.parse(JSON.stringify(category.sub));
                            const chunks = [];
                            const splitNum = category.sub.length / 4;

                            for (let x = 0; x < splitNum; x++) {
                              chunks.push(sub.slice(0, splitNum));
                              sub.splice(0, splitNum);
                            }

                            return (
                              chunks.map((chunk: any, index: number) => (
                                <div key={index} className="nav__subCol">
                                  {chunk.map((subCategory: any, s: any) => (
                                    <div
                                      key={s}
                                      className={
                                        'nav__item' +
                                        (subCategory.sub && subCategory.sub.length > 0
                                          ? ' hasSub'
                                          : '') +
                                        (this.state.openedItems.indexOf(`${i}_e${s}`) !== -1
                                          ? ' isOpened'
                                          : '')
                                      }
                                    >
                                      <NavLink
                                        className="nav__link"
                                        to={subCategory.link || ''}
                                        onClick={e => {
                                          if (subCategory.sub && subCategory.sub.length > 0) {
                                            e.preventDefault();
                                            this.toggleItem(`${i}_e${s}`);
                                          }
                                        }}
                                      >

                                        <span onClick={() => {
                                          if (subCategory.link) {
                                            this.props.history.push(subCategory.link);
                                          }
                                        }}>
                                          {subCategory.value}
                                        </span>
                                      </NavLink>
                                      {/* Lvl 3 */}
                                      {subCategory.sub && (
                                        <div className={'nav__sub'}>
                                          <Nav type="sub">
                                            {subCategory.sub.map((item: any, key: any) => {
                                              return (
                                                <div key={key} className="nav__item">
                                                  <NavLink
                                                    to={item.link || ''}
                                                    className="nav__link"
                                                  >
                                                    {item.value}
                                                  </NavLink>
                                                </div>
                                              );
                                            })}
                                          </Nav>
                                        </div>
                                      )}
                                    </div>
                                  ))}
                                </div>
                              )
                              )
                            );
                          })()
                          :
                          (category.sub.map((subCategory: any, s: any) => {
                            return (
                              <div
                                key={s}
                                className={
                                  'nav__item' +
                                  (subCategory.sub && subCategory.sub.length > 0
                                    ? ' hasSub'
                                    : '') +
                                  (this.state.openedItems.indexOf(`${i}_${s}`) !== -1
                                    ? ' isOpened'
                                    : '')
                                }
                              >
                                <NavLink
                                  className="nav__link"
                                  to={subCategory.link || ''}
                                  onClick={e => {
                                    if (subCategory.sub && subCategory.sub.length > 0) {
                                      e.preventDefault();
                                      this.toggleItem(`${i}_${s}`);
                                    }
                                  }}
                                >

                                  <span onClick={() => {
                                    if (subCategory.link) {
                                      this.props.history.push(subCategory.link);
                                    }
                                  }}>
                                    {subCategory.value}
                                  </span>
                                </NavLink>
                                {/* Lvl 3 */}
                                {subCategory.sub && (
                                  <div className={'nav__sub'}>
                                    <Nav type="sub">
                                      {subCategory.sub.map((item: any, key: any) => {
                                        return (
                                          <div key={key} className="nav__item">
                                            <NavLink
                                              to={item.link || ''}
                                              className="nav__link"
                                            >
                                              {item.value}
                                            </NavLink>
                                          </div>
                                        );
                                      })}
                                    </Nav>
                                  </div>
                                )}
                              </div>
                            );
                          })
                          )
                        }
                      </Nav>
                    </div>
                  )}
              </div>
            );
          })}
        </div>
        {/* Shadow */}
        <div className="nav__shadow" />
      </React.Fragment>
    );
  }
}

const getTopParent = (
  categoryId: string,
  allCategories: Array<INavLink>,
): any => {
  const category = allCategories.find(c => c.id == categoryId);

  if (!category) {
    return;
  }

  if (category.parentCategory != null) {
    return getTopParent(category.parentCategory.id, allCategories);
  }

  return category;
};

// export default Navbar;
export default withRouter(Navbar);



// WEBPACK FOOTER //
// ./src/modules/Nav/Navbar.tsx